import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "d-flex align-items-center mb-2" }
const _hoisted_3 = { class: "me-1" }
const _hoisted_4 = ["onUpdate:modelValue"]
const _hoisted_5 = ["onUpdate:modelValue"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick", "disabled"]
const _hoisted_10 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_caret_up = _resolveComponent("icon-caret-up")!
  const _component_icon_caret_down = _resolveComponent("icon-caret-down")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "btn btn-sm btn-success me-1",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
      }, " + "),
      _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "d-flex align-items-center mb-2",
        key: i
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(i + 1) + ". ", 1),
        (!_ctx.options || _ctx.options.length == 0)
          ? _renderSlot(_ctx.$slots, "default", {
              key: 0,
              item: _ctx.localValue[i]
            }, () => [
              _withDirectives(_createElementVNode("input", {
                class: "me-2 form-control",
                type: "text",
                "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[i]) = $event)
              }, null, 8, _hoisted_4), [
                [_vModelText, _ctx.localValue[i]]
              ])
            ])
          : _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 1,
              class: "me-2 form-control",
              "onUpdate:modelValue": ($event: any) => ((_ctx.localValue[i]) = $event)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableOptions(i), (item) => {
                return (_openBlock(), _createElementBlock("option", { value: item }, _toDisplayString(item), 9, _hoisted_6))
              }), 256))
            ], 8, _hoisted_5)), [
              [_vModelSelect, _ctx.localValue[i]]
            ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-danger ms-2",
            onClick: ($event: any) => (_ctx.remove(i))
          }, " - ", 8, _hoisted_8),
          (_ctx.showMoves)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("button", {
                  class: "btn btn-sm btn-link ms-2",
                  onClick: ($event: any) => (_ctx.moveUp(i)),
                  disabled: i == 0
                }, [
                  _createVNode(_component_icon_caret_up)
                ], 8, _hoisted_9),
                _createElementVNode("button", {
                  class: "btn btn-sm btn-link ms-2",
                  onClick: ($event: any) => (_ctx.moveDown(i)),
                  disabled: i == _ctx.localValue.length - 1
                }, [
                  _createVNode(_component_icon_caret_down)
                ], 8, _hoisted_10)
              ], 64))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}